import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'

import {
  getPageBrowserTabTitleWithEntityName,
  useAsyncCallback,
  useNotification,
  usePageBrowserTabTitle,
} from '../../../hooks'
import { useAsyncEntity } from '../../Entity'
import { EntityPageProfileLayout } from '../../Page'
import { getNewsboardPostProfile, updateNewsboard } from '../Newsboard.api'
import { NewsboardPostProfileActionsWidget } from '../NewsboardPostProfileActionsWidget'
import { NewsboardPostProfileContextProvider } from '../NewsboardPostProfileContextProvider'
import { NewsboardPostProfileHeader } from '../NewsboardPostProfileHeader'
import { NewsboardPostProfileTabs } from '../NewsboardPostProfileTabs'
import { NewsboardPostProfileWidgetList } from '../NewsboardPostProfileWidgetList'

import { QA_NAME_NEWSBOARD_POST_PROFILE_PAGE } from './NewsboardPostProfile.constants'
import { getNewsboardPostProfilePreparedData } from './NewsboardPostProfile.utils'

function NewsboardPostProfile() {
  const { postId } = useParams()

  const { t } = useTranslation()
  const { handleAddErrorNotification } = useNotification()

  const [modal, setModal] = useState(null)

  const pageScrollWrapperRef = useRef(null)

  function handleCloseModal() {
    setModal(null)
  }

  async function getProfileData() {
    return getNewsboardPostProfile(postId)
  }

  const updateProfileData = useAsyncCallback(
    data => {
      return updateNewsboard(postId, data).catch(error => {
        handleAddErrorNotification('Error.CommonApiRequestFailKey')

        throw error
      })
    },
    [postId]
  )

  const {
    entityData,
    handleEntityReload,
    handleUpdateEntity,
    isInitiated,
    serverError,
  } = useAsyncEntity({
    getProfileData,
    updateProfileData,
  })

  const postData = getNewsboardPostProfilePreparedData(entityData)

  usePageBrowserTabTitle({
    isLoading: !isInitiated,
    pageTitle: getPageBrowserTabTitleWithEntityName({
      name: postData?.title,
      title: t('BrowserTab.NewsboardPostProfileTabTitleKey'),
    }),
  })

  return (
    <NewsboardPostProfileContextProvider
      handleCloseModal={handleCloseModal}
      handleEntityReload={handleEntityReload}
      handleUpdateEntity={handleUpdateEntity}
      isInitiated={isInitiated}
      postData={postData}
      setModal={setModal}
    >
      <EntityPageProfileLayout
        Header={NewsboardPostProfileHeader}
        actionsWidget={
          <NewsboardPostProfileActionsWidget isSkeleton={!isInitiated} />
        }
        qaName={QA_NAME_NEWSBOARD_POST_PROFILE_PAGE}
        scrollWrapperRef={pageScrollWrapperRef}
        serverError={serverError}
        widgets={<NewsboardPostProfileWidgetList />}
      >
        <NewsboardPostProfileTabs />
        {modal}
      </EntityPageProfileLayout>
    </NewsboardPostProfileContextProvider>
  )
}

export default NewsboardPostProfile
